module.exports = __webpack_public_path__ + "static/media/data-icon.97cb005d.svg";